<template>
    <div class="bImage" :class="{'auth-stage': isAuthStage}">
      <!-- <button @click="test">test</button> -->
      <div class="wrapper" :class="isAuthStage ? 'auth-stage-wrapper' : 'red'">
        <div class="container">
          <nav-bar v-if="!isAuthStage"/>
          <div class="row" v-if="$route.name === 'home'">
            <div class="col-md-10 offset-md-1">

              <div class="modalApp" v-if="isShowModal" @click="openModal()">
                <i class="fa fa-android fa-2x"></i> 
                {{$t('h_download_app')}}
                <span class="close-icon">
                  <i class="fa fa-times"></i>
                </span>
              </div>

              <h4 class="home-header">{{$t('text1')}}</h4>
              <hr class="home-hr">

              <div class="row">
                <div class="col-md-2 align-center-mobile" style="text-align: center !important">
                  <i class="fa fa-youtube" style="font-size: 80px; margin-top: 10px;"></i>
                </div>
                <div class="col-md-10 home-desc-block">
                  <router-link class="media-body" :to="{name: 'videoPage'}">
                    <h4 class="mt-0 mb-1 home-desc-header"><u>{{$t('text1-1')}}</u></h4>
                    <p class="home-desc-p">
                      {{$t('text1-2')}}
                    </p>
                  </router-link>
                </div>
              </div>

              <div class="row">
                <div class="col-md-2 align-center-mobile">
                  <i class="icon-019-elephant" style="font-size: 80px;"></i>
                </div>
                <div class="col-md-10 home-desc-block">
                  <router-link class="media-body" :to="{name: 'bulletinBoard'}">
                    <h4 class="mt-0 mb-1 home-desc-header"><u>{{$t('text2')}}</u></h4>
                    <p class="home-desc-p">
                      {{$t('text3-1')}}
                      <span class="home-highlight">{{jobAds}}</span>
                      {{$t('text3-2')}}
                    </p>
                  </router-link>
                </div>
              </div>

              <div class="row">
                <div class="col-md-2 align-center-mobile">
                  <i class="icon-004-circus-tent" style="font-size: 80px;"></i>
                </div>
                <div class="col-md-10 home-desc-block">
                  <router-link class="media-body" :to="{name: 'search'}">
                    <h4 class="mt-0 mb-1 home-desc-header"><u>{{$t('text4')}}</u></h4>

                    <p class="home-desc-p">
                      {{$t('text5-1')}} 
                      <span class="home-highlight">{{artists + availableArtists}}</span>
                      {{$t('text5-2')}}
                      <!-- <span class="home-highlight">{{availableArtists}}</span>
                      {{$t('text5-3')}} -->
                    </p>
                  </router-link>
                </div>
              </div>

              <div class="row">
                <div class="col-md-10 offset-md-1 home-desc-block signup">
                  <router-link class="media-body" :to="{name: 'login'}">
                    <p class="home-desc-header signup">
                      {{$t('home_signup')}}
                      <!-- <small>{{$t('home_career')}}</small> -->
                    </p>
                  </router-link>
                  <router-link class="media-body" :to="{name: 'privacyPolicy'}" target="_blank">
                    <p class="home-desc-header signup">
                      <small><u>{{`~ ${$t('reg_privacy_policy1')} universtage.com ~`}}</u></small>
                    </p>
                  </router-link>
                </div>
              </div>

              <!-- <li class="media" v-if="false">
                <i class="pe-7s-display1 mr-3" style="font-size: 40px"></i>
                <router-link class="media-body" :to="{name: 'statistics'}">
                  <h4 class="mt-0 mb-1"><u>{{$t('text6')}}</u></h4>
                  {{$t('text7')}}
                  <p style="text-decoration: underline;">{{$t('withoutReg')}}</p>
                </router-link>
              </li> -->
            </div>
          </div>
          <router-view/>
        </div>
        <div v-if="!isAuthStage" class="footer container-fluid">
          <div class="row">
            <div class="col-md-12">
              <p class="copyright text-center">
            &copy; {{year}} <a href="http://www.universtage.com">Universtage</a> - the intergalactic network for stars!
            <br>
            <a href="https://twitter.com/universtage?lang=en" target="_blank">
              <span class="fa-stack fa-lg">
                <i class="fa fa-twitter fa-stack-1x"></i>
              </span>
            </a>
            <a href="https://t.me/UniverstageNews" target="_blank">
              <span class="fa-stack fa-lg telegram">
                <i class="fa fa-telegram fa-stack-1x"></i>
              </span>
            </a>
            <a href="https://www.instagram.com/universtage" target="_blank">
              <span class="fa-stack fa-lg instagram">
                <i class="fa fa-instagram fa-stack-1x"></i>
              </span>
            </a>
          </p>
            <div class="attribution">
              <p>
                Icons made by 
                <a href="https://www.freepik.com/?__hstc=57440181.c749577025ae65ab048038f23583f5f6.1556127930074.1557828155445.1557839019492.12&__hssc=57440181.4.1557839019492&__hsfp=2403621687" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" 		    title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a>
              </p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import NavBar from '../components/HomeNavBar'
  import { mapActions } from 'vuex';
  import { STATS_LOAD } from "../store/actions/userConst";
  import { isAndroid } from 'mobile-device-detect';

  export default {
    components: { NavBar },
    computed: {
      isAuthStage() {
        return this.$route.name === 'login' || this.$route.name === 'register';
      },
    },
    data() {
      return {
          year: new Date().getFullYear(),
          jobAds: 500,
          availableArtists: 100,
          artists: 100,
          isShowModal: isAndroid && (window.navigator.userAgent.indexOf('Universtage') === -1),
      }
    },
    created() {
      if (this.$route.name !== 'home') return;
      this.STATS_LOAD()
      .then(res=> {
        this.jobAds = res.jobAds;
        this.availableArtists = res.availableArtists;
        this.artists = res.artists;
        // console.log(res);
      }).catch(err=>console.log(err));
    },
    methods: {
      ...mapActions([STATS_LOAD]),
      test() {
        console.log(process.env);
      },
      openModal() {
        window.open('https://play.google.com/store/apps/details?id=com.clevertech.universtage&hl=en', '_blank');
        this.isShowModal = false;
      }
    }
  }
</script>

<style lang="scss">
  .bImage.auth-stage {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    background-color: #090708;
    background-image: url('../assets/img/auth-stage-horizontal.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .auth-stage-wrapper {
    background: transparent;
  }
  @media (max-width: 992px) {
    .bImage.auth-stage {
      background-image: url('../assets/img/auth-stage-vertical.png');
    }
  }
  .wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
  }
  .container {
    flex: 1 0 auto;
    h4, i {
      color: #FFFFFF;
      font-weight: normal;
    }
  }
  .footer {
    flex: 0 0 auto;
  }

  .bImage {
    background: url(../assets/img/full-screen-image-1.jpg);
    background-size: cover;
    background-position: center center;
    height: 100vh;
    /*opacity: .9;*/
  }
  .red {
    background: linear-gradient(to bottom, #FB404B 0%, rgba(187, 5, 2, 0.7) 100%);
    /*background-color: #ff3b30;*/
    /*opacity: .8;*/
  }
  .media-body {
    color: #FFFFFF;
    &:hover {
      color: #FFFFFF;
      text-decoration: none;
    }
  }
  .copyright {
    a {
      &:hover {color: white;}
      color: white;
      font-size: 14px;
    }
    color: rgba(255, 255, 255, 0.5);
    font-size: 14px;
  }
  hr {
    border-top: 1px solid rgba(255, 255, 255, 0.3) !important;
  }
  .home-header {
    text-align: center;
    font-size: 30px;
    font-weight: bold !important;
    text-shadow: 1px 1px 1px black;
    text-transform: uppercase;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .home-hr {
    border-color: white !important;
    margin-bottom: 20px;
  }
  .home-desc-header {
    font-size: 25px;
    font-weight: bold !important;
    text-shadow: 1px 1px 1px #00000054;
  }
  .signup {
    text-transform: uppercase;
    text-align: center;
  }
  .signup small {
    font-size: 15px;
    font-weight: 400;
    display: block;
    text-transform: none;
  }
  .home-desc-block {
    margin-top: 10px;
  }
  .home-desc-block .signup {
    // margin-top: 20px;
  }
  .home-desc-p {
    margin-top: 10px;
    font-size: 20px;
    text-shadow: 1px 1px 1px #00000054;
  }
  .home-highlight {
    font-size: 25px;
    font-weight: bold;
    // background-color: white;
    // color: #ff0000bd;
    color: white;
    border-radius: 4px;
    padding-left: 5px;
    padding-right: 5px;
    // text-shadow: none;
    text-shadow: 1px 1px 1px black;
  }
  .attribution a,
  .attribution p {
    text-align: center !important;
    color: #cccccc !important;
    font-size: 9px !important;
    margin-bottom: 5px;
    margin-top: 0;
  }
  .attribution a:hover {
    color: #cccccc !important;
  }
  .modalApp {
    background-color: white;
    border-radius: 6px;
    padding: 10px 15px 15px 10px;
    font-size: 16px !important;
    position: fixed;
    width: 90vw;
    z-index: 999999;
    font-weight: 600;
    bottom: 30px;
    border: 2px solid #28a745;
    text-align: center;
    cursor: pointer;
  }
  .modalApp .fa {
    color: green;
    padding-right: 10px;
    position: relative;
    top: 3px;
  }
  .close-icon {
    color: #222222 !important;
    position: absolute;
    right: -2px;
    top: 0px;
  }
  @media only screen and (max-width: 768px) {
    .home-desc-block .signup {
      margin-bottom: 40px;
      margin-top: 20px;
    }
    .home-desc-p {
      text-align: center
    }
    .home-desc-header {
      text-align: center;
    }
    .align-center-mobile {
      text-align: center !important;
    }
    .home-header {
      font-size: 20px;
    }
    .home-hr {
      margin-bottom: 0px;
    }
    .icon-019-elephant,
    .icon-004-circus-tent {
      font-size: 65px !important;
    }
    .home-desc-header {
      font-size: 20px;
    }
    .home-desc-p {
      margin-top: 0px;
      margin-bottom: 0px;
      font-size: 16px;
    }
    .home-highlight {
      font-size: 20px;
    }
  }
</style>
